<template>
    <div>
        <div class="user_right">
            <h1 class="urs_h1">收货地址</h1>
            <div class="as_h" id="as_h" v-for="(item,index) in list" :key="index">
                <div class="as_li">
                <!-- <a href="user_address.php?act=edit&amp;id=11068331" class="as_li"> -->
                    <div class="s_tp">
                        <b class="s_name">{{item.name}}</b>
                        <em class="s_mob">{{item.tel}}</em>
                        <em class="is_mor">默认</em>
                    </div>
                    <p class="s_dd" style="width:100%;">{{item.province}}{{item.city}}{{item.area}}{{item.town}}{{item.address}}</p>
                    <p class="c_edit" @click="$router.push({path: '/edit_address', query:{id:item.id}})" ></p>
                    <p class="c_edel" @click="del_address(item.id)"></p>
                <!-- </a> -->
                </div>
            </div>
            <a href="javascript:;" @click="$router.push({path: '/add_address'})" class="add_newa">新增收货地址</a>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            list:[]
        }
    },
    mounted(){
        this.getAddress(JSON.parse(window.localStorage.getItem("user")).id);
    },
    methods:{
        getAddress(id){
            var params = {};
            params.id = id || "";
            this.$api.getUser.getAddress(params).then(res=>{
                this.list = res.result;
            })
        },
        del_address(id){
            var params = {};
            params.id = id || "";
            params.uid = JSON.parse(window.localStorage.getItem("user")).id || "";
            this.$api.getUser.delAddres(params).then(res=>{
                if(res.code == 200){
                    this.$alert('删除成功', '提示', {
                        confirmButtonText: '确定',
                    }).then(()=>{
                        window.location.reload();
                    });
                    
                }
            })
        }
    }
}
</script>

<style scoped>
@import url('../../assets/css/user.css');
</style>


// WEBPACK FOOTER //
// src/components/address/Index.vue